import type {AfriexTier} from '@/types';

const UserTierTable = ({
  tierInfo,
  transactionCount,
}: {
  tierInfo: AfriexTier;
  // Sourced from `person.tierInfo.transactionCount`, which the server omits
  // until the person transacts under the tier; the cell renders empty then.
  transactionCount?: number;
}) => (
  <div>
    <div className="mb-2 py-2 px-3 flex items-center gap-3 bg-gray-100 justify-between dark:bg-gray-900">
      <p className="text-slate-500 text-sm dark:text-slate-100">
        Current Promo
      </p>
      <p className="text-sm font-medium text-gray-700 w-1/2 dark:text-gray-100">
        {tierInfo?.name}
      </p>
    </div>

    <div className="mb-2 py-2 px-3 flex items-center gap-3 bg-gray-100 justify-between dark:bg-gray-900">
      <p className="text-slate-500 text-sm dark:text-slate-100">
        Transactions Left
      </p>
      <p className="text-sm font-medium text-gray-700 w-1/2 dark:text-gray-100">
        {transactionCount}
      </p>
    </div>

    <div className="mb-2 py-2 px-3 flex items-center gap-3 bg-gray-100 justify-between dark:bg-gray-900">
      <p className="text-slate-500 text-sm dark:text-slate-100">
        Total Transactions Allowed
      </p>
      <p className="text-sm font-medium text-gray-700 w-1/2 dark:text-gray-100">
        {tierInfo?.transactionCountThreshold}
      </p>
    </div>

    <div className="mb-2 py-2 px-3 flex items-center gap-3 bg-gray-100 justify-between dark:bg-gray-900">
      <p className="text-slate-500 text-sm dark:text-slate-100">Tier ID</p>
      <p className="text-sm font-medium text-gray-700 w-1/2 dark:text-gray-100 truncate">
        {tierInfo?.id}
      </p>
    </div>
  </div>
);

export default UserTierTable;
